var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FFB443"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14v4m0 4h.01M28 18c0 5.523-4.477 10-10 10S8 23.523 8 18 12.477 8 18 8s10 4.477 10 10z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiNGRkI0NDMiLz4KPHBhdGggZD0iTTE4IDE0VjE4TTE4IDIySDE4LjAxTTI4IDE4QzI4IDIzLjUyMjggMjMuNTIyOCAyOCAxOCAyOEMxMi40NzcyIDI4IDggMjMuNTIyOCA4IDE4QzggMTIuNDc3MiAxMi40NzcyIDggMTggOEMyMy41MjI4IDggMjggMTIuNDc3MiAyOCAxOFoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgCircleWarning as ReactComponent };